/* eslint-disable */
/*
 * Validates email
 * @param {string} email email address to be validated
 * @returns {string} returns true if email address is valid, false otherwise
 */
const validateEmail = (email) =>
  !!/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
    String(email).toLowerCase(),
  );

/**
 * supportsTypeDate
 * @returns {boolean} Returns true if browser supports input type="date"
 */
function supportsTypeDate() {
  const input = document.createElement(`input`);
  input.setAttribute(`type`, `date`);

  const notADateValue = `not-a-date`;
  input.setAttribute(`value`, notADateValue);

  return input.value !== notADateValue;
}

export default {
  supportsTypeDate,
  validateEmail,
};
